module.exports = __webpack_public_path__ + "static/media/kim.84567083.jpeg";